import HeroTemplate from '../components/Listing/HeroTemplate';
import DateStripTemplate from '../components/Listing/DateStripTemplate';
import FeatureGridTemplate from '../components/Listing/FeatureGridTemplate';
import RuledListTemplate from '../components/Listing/RuledListTemplate';

// Listing templates for the Federation home page. Editors pick them from the
// listing block's Variation menu; the query keeps them current.
const variations = [
  { id: 'asajHero', title: 'Hero (next meet)', template: HeroTemplate },
  { id: 'asajDateStrip', title: 'Date strip', template: DateStripTemplate },
  {
    id: 'asajFeatureGrid',
    title: 'Feature grid',
    template: FeatureGridTemplate,
  },
  { id: 'asajRuledList', title: 'Ruled list', template: RuledListTemplate },
];

export default function install(config) {
  const { listing, gridBlock } = config.blocks.blocksConfig;
  listing.variations = [...listing.variations, ...variations];
  // Listings inside a grid (Results and Rankings side by side)
  if (gridBlock?.blocksConfig?.listing) {
    gridBlock.blocksConfig.listing.variations = [
      ...gridBlock.blocksConfig.listing.variations,
      variations.find((v) => v.id === 'asajRuledList'),
    ];
  }
  return config;
}
